import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheGrandEntrance from "./sections/TheGrandEntrance";
import TheCollector from "./sections/TheCollector";
import SignatureEventTypes from "./sections/SignatureEventTypes";
import TheFanExperience from "./sections/TheFanExperience";
import ATimelessRepertoire from "./sections/ATimelessRepertoire";
import InquiryForm from "./sections/InquiryForm";
import ServiceShowcase from "./sections/ServiceShowcase";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheGrandEntrance />
      <TheCollector />
      <SignatureEventTypes />
      <TheFanExperience />
      <ATimelessRepertoire />
      <ServiceShowcase />
      <InquiryForm />
      <Footer />
    </div>;
}